"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_1 = __importDefault(require("@emotion/styled"));
var defaultProps_1 = __importDefault(require("./defaultProps"));
var Box_1 = __importDefault(require("../Box"));
var useIsBreakpoint_1 = __importDefault(require("../utils/useIsBreakpoint"));
var DesktopFooter_1 = __importDefault(require("./DesktopFooter"));
var MobileFooter_1 = __importDefault(require("./MobileFooter"));
var withSafeAreaInsetBottom_1 = __importDefault(require("../utils/withSafeAreaInsetBottom"));
function Footer(props) {
    var isMd = (0, useIsBreakpoint_1.default)('md');
    return (react_1.default.createElement(Container, { withFloatingCTA: props.withFloatingCTA }, isMd
        ? react_1.default.createElement(DesktopFooter_1.default, __assign({}, props))
        : react_1.default.createElement(MobileFooter_1.default, __assign({}, props))));
}
var FloatingCTAHeight = 60;
var Container = (0, styled_1.default)(Box_1.default)(function (_a) {
    var _b;
    var theme = _a.theme, withFloatingCTA = _a.withFloatingCTA;
    return (_b = {
            backgroundColor: '#4C4D50',
            paddingBottom: withFloatingCTA ? (0, withSafeAreaInsetBottom_1.default)(FloatingCTAHeight + "px") : undefined
        },
        _b[theme.mediaQueries.md] = {
            paddingBottom: 'unset'
        },
        _b);
});
Container.defaultProps = { as: 'footer' };
Footer.defaultProps = defaultProps_1.default;
exports.default = Footer;
